import React from "react";
import { string, array, number, object, bool } from "prop-types";
import { Table } from "antd";

import "./reportTable.css";
import { HeaderDateTime, InfoPopover } from "../../components";
import { DataTransformations } from "../../../utils/data_transformations";
import { DataFormatting } from "../../../utils/data_formatting";
import { ROW_TYPE, PAGES } from "../../core/_utils/constants";

//import ReportsDataTransformations from '../_utils/reportsDataTransformations';
const ReportTable = ({
  aggLevel,
  data,
  tableWidth,
  tableHeight,
  timeAgg,
  loading
}) => {
  //console.log("report table", data);
  function getCellValue(rowIndex, d) {
    // console.log("getCellValue", rowIndex, d);

    let value = null;
    if (data[rowIndex]) {
      if (
        data[rowIndex].expect_data !== null &&
        data[rowIndex].expect_data === false
      )
        value = { css: "na", text: "N/A" };
      else {
        const refRowIndex = data[rowIndex].refRowIndex;
        const refColKey = data[rowIndex].refColKey;
        if (
          refRowIndex !== null &&
          refColKey &&
          data[refRowIndex].data &&
          data[refRowIndex].data[d] &&
          data[refRowIndex].data[d][refColKey] !== null
        )
          value = {
            css: "value",
            text: DataFormatting.formatCellValue(
              data[refRowIndex].data[d][refColKey],
              data[rowIndex].decimalPlaces,
              data[rowIndex].units
            )
          };
      }
    }
    if (value) {
      return <div className={value.css}>{value.text}</div>;
    }
    return null;
  }

  const getFirstColumnCell = index => {
    //console.log("first col", index);
    const row = data[index];
    let element;
    switch (row.rowType) {
      case ROW_TYPE.OBJECT:
        element = (
          <span>
            <InfoPopover row={row} page={PAGES.FINANCIAL} />
            <b>{row.text}</b>
          </span>
        );
        break;
      case ROW_TYPE.VARIABLE:
        element = (
          <span>
            <InfoPopover row={row} page={PAGES.FINANCIAL} />
            <b>{row.text}</b> ({row.units})
          </span>
        );
        break;
      default:
        console.error(`Row type not supported ${row.rowType}`);
        break;
    }

    return <div key={`first-col-${index}`}>{element}</div>;
  };

  const headerData = DataTransformations.getTableReportHeaderData(data);

  const columns = [
    {
      title: aggLevel ? aggLevel.toUpperCase() : "Elements",
      dataIndex: "text",
      render: (text, record, index) => {
        return getFirstColumnCell(index);
      },
      width: 325,
      fixed: "left"
    }
  ];
  if (headerData) {
    // console.log('header data', headerData);
    headerData.forEach((d, i) => {
      columns.push({
        title: (
          <HeaderDateTime
            dt={d}
            dtSubFormat={timeAgg.dtSubFormat}
            dtMainFormat={timeAgg.dtMainFormat}
          />
        ),
        key: d,
        render: (text, record, index) => {
          return getCellValue(index, d);
        },
        width: 100
      });
    });
    // columns.push({
    // 	text:  "Variables",
    // 	width: 150,
    // 	dataIndex: 'rowType',
    // })
  }

  return (
    <div className="cp-report-table">
      <Table
        className="report-table"
        dataSource={data}
        columns={columns}
        pagination={false}
        rowClassName={(record, index) => `row-${record.rowType}`}
        rowKey={(record, index) => `row-${index}`}
        bordered={true}
        size="small"
        scroll={{ x: true, y: tableHeight }}
        loading={loading}
      />
    </div>
  );
};

ReportTable.propTypes = {
  aggLevel: string.isRequired,
  tableWidth: number.isRequired,
  tableHeight: number.isRequired,
  data: array,
  timeAgg: object.isRequired,
  loading: bool
};

export default ReportTable;



// WEBPACK FOOTER //
// ./src/views/reports/report_table/ReportTable.jsx